import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HiverAxios } from "../helpers";
import { AI_QUERIES } from "../../sharedmailbox/AI/Pages/TagsDescription/constants";

const updateTagApi = async (payload) =>
  new Promise((resolve, reject) => {
    HiverAxios({
      url: "/api/update-tag",
      type: "POST",
      params: payload,
      callback: (response) => {
        const { data, status } = response;
        if (status === 200) {
          resolve({ success: true, data });
        } else {
          reject({ success: false });
        }
      },
      onfail: () => {
        reject({ success: false });
      },
    });
  });

const updateNewTagInAiTagsCache = (queryClient, smid, updatedTagData) => {
  queryClient.setQueryData(
    [AI_QUERIES.AI_TAGS_DATA, String(smid)],
    (oldData) => {
      if (!oldData) return oldData;

      const updatedTags = oldData.tags.map((tagData) =>
        tagData.id === updatedTagData.id
          ? { ...tagData, ...updatedTagData }
          : tagData
      );
      return { ...oldData, tags: updatedTags };
    }
  );
};

export const useUpdateTag = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateTagApi,
    onSuccess: (res) => {
      const { smid, ...updatedTagData } = res.data;
      // Update data in all tags cache so as to avoid unecessary all tags fetching on each tag update 
      updateNewTagInAiTagsCache(queryClient, smid, updatedTagData);
    },
  });
};
